import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const crearOEditarVersionContrato = async (versionContrato) => {
    try {
        if (versionContrato.id) {
            const resp = await axios.put(
                `${API_URL}/administrar/versionesContratos/${versionContrato.id}`,
                versionContrato,
                { headers: getHeaders() }
            );

            return resp.data;
        }

        const resp = await axios.post(
            `${API_URL}/administrar/versionesContratos`,
            versionContrato,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarVersionesContratos = async (id_version_contrato) => {
    try {
        const resp = await axios.delete(
            `${API_URL}/administrar/versionesContratos/${id_version_contrato}`,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const activarVersionesContratos = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/administrar/versionesContratos/activar/${data.id}`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectTipoContrato = async () => {
    try {
        const resp = await axios.get(
            `${API_URL}/versionesContratos/selectTipoContrato`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectTipoVersiones = async () => {
    try {
        const resp = await axios.get(
            `${API_URL}/versionesContratos/selectTipoVersion`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerVersionesPorTipoContrato = async (idTipoContrato) => {
    try {
        const resp = await axios.get(
            `${API_URL}/administrar/versionesContratos/obtenerPorTipoContrato/${idTipoContrato}`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};